<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g>
    <path fill="none" d="M99.75,49C71.766,49,49,71.766,49,99.75c0,27.984,22.766,50.75,50.75,50.75c27.984,0,50.75-22.766,50.75-50.75
      C150.5,71.766,127.734,49,99.75,49z M126,111H92V77h8v26h26V111z"/>
    <path class="color" fill="#F45B5B" d="M99.75,39C66.252,39,39,66.252,39,99.75c0,33.498,27.252,60.75,60.75,60.75
      c33.498,0,60.75-27.252,60.75-60.75C160.5,66.252,133.248,39,99.75,39z M99.75,150.5C71.766,150.5,49,127.734,49,99.75
      C49,71.766,71.766,49,99.75,49c27.984,0,50.75,22.766,50.75,50.75C150.5,127.734,127.734,150.5,99.75,150.5z"/>
    <polygon class="color" fill="#F45B5B" points="100,77 92,77 92,111 126,111 126,103 100,103 "/>
  </g>
  </svg>

</template>

<script>
export default {
  name: 'ClockIcon'
}
</script>
